import {  React } from 'react';
import logo from '../../assets/icons/logo.png'
import { Link, animateScroll as scroll } from "react-scroll";



export default function Navbar() {
  return <>
   <nav className="navbar navbar-expand-sm navbar-bg fixed-top py-2">
        <div className="container">
        <Link className="navbar-brand text-1 " to="/"><img className='px-3' src={logo}/>LuminaryCloud</Link>
        <button className="navbar-toggler d-lg-none" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavId" aria-controls="collapsibleNavId" aria-expanded="false" aria-label="Toggle navigation">
        <i className="fa-solid fa-arrow-down-short-wide icon-nav border-0"></i>
        </button>

        <div className="collapse navbar-collapse" id="collapsibleNavId">

           <ul className="navbar-nav ms-auto  mt-2 mt-lg-0">

           <li className="nav-item">
            
          
           <Link className="nav-link px-3" to="about" smooth={true} duration={300} activeClass="active">About</Link>
           </li>

           
           <li className="nav-item">

           <Link className="nav-link px-3"  to="experiences" smooth={true} duration={300} activeClass="active"> Services</Link>
           
         
             
           </li>
           
           <li className="nav-item">
             <Link className="nav-link px-3" to="pricing" smooth={true} duration={300} activeClass="active" >Pricing</Link>
           </li>

           <li className="nav-item">
             <Link className="nav-link px-3" to="contact" smooth={true} duration={300} activeClass="active">Payments</Link>
           </li>



         </ul>
         


        </div>
       </div>
     </nav>



  </>
}
